var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tbody", [
    _c(
      "tr",
      { staticClass: "cursor-pointer w-max rowHeight" },
      [
        _c(
          "RouterLink",
          {
            staticClass: "flex items-center contents",
            attrs: {
              to: {
                name: _vm.postingDetailsRouteName,
                params: { id: _vm.posting.id },
              },
            },
          },
          [
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 pb-4 pt-6 text-left sm:truncate" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "cursor-pointer customText capitalize relative",
                    },
                    [_vm._v(" " + _vm._s(_vm.posting.job_title) + " ")]
                  ),
                ]
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left sm:truncate" },
                [
                  _c("CardBodyItem", {
                    attrs: {
                      content: _vm.location,
                      additionalClass: "block adjustMargin",
                      textStyleClasses: "customText",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left" },
                [
                  _vm.skillss.length
                    ? _c(
                        "CardBodyItem",
                        {
                          attrs: {
                            additionalClass: "block adjustMargin",
                            textStyleClasses: "customText",
                            wide: "",
                          },
                        },
                        [
                          _c("ChipsWithMoreNew", {
                            attrs: { chipWithLinkDatas: _vm.skillss },
                          }),
                        ],
                        1
                      )
                    : _c("p", [_vm._v("n/a")]),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left" },
                [
                  _c(
                    "CardBodyItem",
                    {
                      attrs: {
                        additionalClass: "block adjustMargin",
                        textStyleClasses: "customText",
                      },
                    },
                    [
                      _c("p", { staticClass: "customText" }, [
                        _vm._v(_vm._s(_vm.badgeData.value)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left" },
                [
                  _c("CardBodyItem", {
                    attrs: {
                      textStyleClasses: "customText",
                      additionalClass: "block adjustMargin",
                      content: _vm._f("moment")(
                        _vm.posting.created_at,
                        "D MMM, YYYY"
                      ),
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left" },
                [
                  _c("CardBodyItem", {
                    attrs: {
                      content: _vm.type,
                      additionalClass: "block adjustMargin",
                      textStyleClasses: "customText",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left" },
                [
                  _c("CardBodyItem", {
                    staticClass: "text-base",
                    attrs: {
                      content: _vm.status,
                      additionalClass: "block adjustMargin",
                      textStyleClasses: "customText",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c(
                "div",
                { staticClass: "px-2 py-4 text-left" },
                [
                  _c("CardBodyItem", {
                    staticClass: "text-base",
                    attrs: {
                      content: _vm.postedAt,
                      textStyleClasses: "customText",
                      contentContainerClass: "overflow-visible",
                      additionalClass: "block adjustMargin",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("td", { staticClass: "table-cell w-28" }, [
              _c("div", { staticClass: "px-2 py-4 text-left" }, [
                _vm.canEdit
                  ? _c(
                      "div",
                      { staticClass: "flex items-center ml-auto" },
                      [
                        _c("PostingActivenessToggleButton", {
                          attrs: {
                            postingId: _vm.posting.id,
                            active: _vm.posting.active,
                          },
                        }),
                        _c("UiButton", {
                          staticClass: "ml-4",
                          attrs: {
                            variant: "linkButton",
                            size: "no",
                            buttonText: "Edit",
                          },
                          nativeOn: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.dialog = true
                            },
                          },
                        }),
                        _vm.dialog
                          ? _c("PostingModal", {
                              attrs: {
                                companyId: _vm.companyId,
                                data: _vm.posting,
                                managerId: _vm.managerId,
                              },
                              model: {
                                value: _vm.dialog,
                                callback: function ($$v) {
                                  _vm.dialog = $$v
                                },
                                expression: "dialog",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }